module.exports = __webpack_public_path__ + "static/media/greenchoice.56e15359.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/greenchoice.png
// module id = 18
// module chunks = 0